import {requestDelete, requestGet, requestPost, requestPut} from "../util/request";
import {
    boardProps,
    boardPutProps,
    caseBoardDetailProps,
    caseBoardInfoProps,
    caseBoardProps,
    AlbumItem
} from "../types/board.types";



export const createBoard = async (body?: {boardType: "moodBoard" | "inspireBoard"}): Promise<boardProps | null> => {
    try {
        const response = await requestPost(
            `${process.env.REACT_APP_APPLICATION_MAIN_INTERFACE}/api/mood/board/create`,
            {...body}, true
        ) as {code: number, data: boardProps, message: string};

        const { code, data, message } = response;

        if (code === 200) {
            return data;
        }

        return null;
    } catch (error) {
        throw error instanceof Error ? error : new Error('network error');
    }
}

export const updateBoardName = async (boardInfo: boardPutProps): Promise<boolean> => {
    try {
        const response = await requestPost(
            `${process.env.REACT_APP_APPLICATION_MAIN_INTERFACE}/api/mood/board/rename`,
            boardInfo, true
        ) as {code: number, data: boolean, message: string};

        const { code, data, message } = response;

        if (code === 200) {
            return data;
        }

        return false;
    } catch (error) {
        throw error instanceof Error ? error : new Error('network error');
    }
}

export const fetchBoardList = async (): Promise<boardProps[]> => {
    try {
        const response = await requestGet(
            `${process.env.REACT_APP_APPLICATION_MAIN_INTERFACE}/api/mood/board/list`, true
        ) as {code: number, data: boardProps[], message: string};

        const { code, data, message } = response;

        if (code === 200) {
            return data;
        }

        return [];
    } catch (error) {
        throw error instanceof Error ? error : new Error('Upload failed');
    }
};

export const deleteBoardList = async (boardId: string): Promise<boolean> => {
    try {
        const response = await requestDelete(
            `${process.env.REACT_APP_APPLICATION_MAIN_INTERFACE}/api/mood/board?boardId=${boardId}`, true
        ) as {code: number, data: boolean, message: string};

        const { code, data, message } = response;

        if (code === 200) {
            return data;
        }

        return false;
    } catch (error) {
        throw error instanceof Error ? error : new Error('Upload failed');
    }
};

export const getCaseBoardList = async (pageNum: number, pageSize: number): Promise<caseBoardProps | null> => {
    try {
        const response = await requestGet(
            `/api/mood/userCase/page?pageNum=${pageNum}&pageSize=${pageSize}`,
        ) as {code: number, data: caseBoardProps, message: string};

        const { code, data, message } = response;

        if (code === 200) {
            return data;
        }

        return null;
    } catch (error) {
        throw error instanceof Error ? error : new Error('Upload failed');
    }
};

export const getCaseBoardDetail = async (useCaseId: number): Promise<caseBoardDetailProps[] | null> => {
    try {
        const response = await requestGet(
            `/api/mood/userCase/images?useCaseId=${useCaseId}`,
        ) as {code: number, data: caseBoardDetailProps[], message: string};

        const { code, data, message } = response;

        if (code === 200) {
            return data;
        }

        return null;
    } catch (error) {
        throw error instanceof Error ? error : new Error('Upload failed');
    }
};

export const createForkBoard = async (boardId: string): Promise<string | null> => {
    try {
        const response = await requestGet(
            `/api/mood/userCase/forkTempBoard?boardId=${boardId}`,
        ) as {code: number, data: string, message: string};

        const { code, data, message } = response;

        if (code === 200) {
            return data;
        }

        return null;
    } catch (error) {
        throw error instanceof Error ? error : new Error('Upload failed');
    }
};

export const getBoardInfo = async (boardId: string): Promise<caseBoardInfoProps | null> => {
    try {
        const response = await requestGet(
            `${process.env.REACT_APP_APPLICATION_MAIN_INTERFACE}/api/mood/userCase/boardDetailPublic?boardId=${boardId}`, true
        ) as {code: number, data: caseBoardInfoProps, message: string};

        const { code, data, message } = response;

        if (code === 200) {
            return data;
        }

        return null;
    } catch (error) {
        throw error instanceof Error ? error : new Error('Upload failed');
    }
};

// ==================== 画册管理 ====================

export const createAlbum = async (albumName: string): Promise<AlbumItem | null> => {
    try {
        const response = await requestPost(
            `${process.env.REACT_APP_APPLICATION_MAIN_INTERFACE}/api/mood/album/create`,
            { albumName }, true
        ) as { code: number, data: AlbumItem, message: string };

        const { code, data } = response;

        if (code === 200) {
            return data;
        }

        return null;
    } catch (error) {
        throw error instanceof Error ? error : new Error('Upload failed');
    }
};

export const fetchAlbumList = async (): Promise<AlbumItem[]> => {
    try {
        const response = await requestGet(
            `${process.env.REACT_APP_APPLICATION_MAIN_INTERFACE}/api/mood/album/list`, true
        ) as { code: number, data: AlbumItem[], message: string };

        const { code, data } = response;

        if (code === 200) {
            return data;
        }

        return [];
    } catch (error) {
        throw error instanceof Error ? error : new Error('Upload failed');
    }
};

export const renameAlbum = async (albumId: string, newName: string): Promise<boolean> => {
    try {
        const response = await requestPost(
            `${process.env.REACT_APP_APPLICATION_MAIN_INTERFACE}/api/mood/album/rename`,
            { albumId, newName }, true
        ) as { code: number, data: boolean, message: string };

        const { code, data } = response;

        if (code === 200) {
            return data;
        }

        return false;
    } catch (error) {
        throw error instanceof Error ? error : new Error('Upload failed');
    }
};

export const deleteAlbum = async (albumId: string): Promise<boolean> => {
    try {
        const response = await requestDelete(
            `${process.env.REACT_APP_APPLICATION_MAIN_INTERFACE}/api/mood/album?albumId=${albumId}`, true
        ) as { code: number, data: boolean, message: string };

        const { code, data } = response;

        if (code === 200) {
            return data;
        }

        return false;
    } catch (error) {
        throw error instanceof Error ? error : new Error('Upload failed');
    }
};

export const moveBoardToAlbum = async (boardId: string, albumId: string | null): Promise<boolean> => {
    try {
        const response = await requestPost(
            `${process.env.REACT_APP_APPLICATION_MAIN_INTERFACE}/api/mood/album/moveBoard`,
            { boardId, albumId }, true
        ) as { code: number, data: boolean, message: string };

        const { code, data } = response;

        if (code === 200) {
            return data;
        }

        return false;
    } catch (error) {
        throw error instanceof Error ? error : new Error('Upload failed');
    }
};

export const batchMoveBoardsToAlbum = async (boardIds: string[], albumId: string | null): Promise<boolean> => {
    try {
        const response = await requestPost(
            `${process.env.REACT_APP_APPLICATION_MAIN_INTERFACE}/api/mood/album/batchMoveBoards`,
            { boardIds, albumId }, true
        ) as { code: number, data: boolean, message: string };

        const { code, data } = response;

        if (code === 200) {
            return data;
        }

        return false;
    } catch (error) {
        throw error instanceof Error ? error : new Error('Upload failed');
    }
};
